// src/api.js
import axios from "axios";
import { API_BASE_URL } from "./settings";

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// Add a response interceptor to handle 401 errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Redirect to login page if not already there
      if (window.location.pathname !== "/login") {
        // window.location.href = "/login";
        window.location.href = `${API_BASE_URL}/api/login/`;
      }
    }
    return Promise.reject(error);
  }
);

export default api;
